module.exports = __webpack_public_path__ + "microphone.jpg?260552c4515458fe82574da9328d2a3f";